import { GetContactListRequestParams } from '../types/requests/contacts'

export const QUERY_KEYS = {
  apiStatus: ['apiStatus'],
  bannerNotification: () => ['banner-notification'],
  contacts: ['contacts'],
  contactDetails: (contactId: number) => [QUERY_KEYS.contacts, { contactId }],
  contactList: (params?: GetContactListRequestParams) =>
    params ? [QUERY_KEYS.contacts, params] : ['contacts'],
  currentSession: ['current-session'],
  emailVerificationRequest: () => ['email-verification-request'],
  globalSearch: (searchTerm: string) => ['global-search', { searchTerm }],
  resetPasswordRequest: (resetPasswordRequestToken: string) =>
    resetPasswordRequestToken
      ? [
          'reset-password-request',
          { resetPasswordRequestId: resetPasswordRequestToken },
        ]
      : ['reset-password-request'],
  sessionList: () => ['sessions'],
  subscription: () => ['subscription'],
  tagDetails: (tagId: number) => (tagId ? ['tags', { tagId }] : ['tags']),
  tagList: () => ['tags'],
  usage: () => ['usage'],
}
